/* Annave theme — vanilla JS, no dependencies. */
(function () {
  'use strict';

  var routes = window.routes || {};
  var strings = window.themeStrings || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function announce(msg) { var el = $('#A11yStatus'); if (el) { el.textContent = ''; setTimeout(function () { el.textContent = msg; }, 50); } }

  /* ------------------------------------------------------------------
     Drawers (menu + cart) with focus trap
     ------------------------------------------------------------------ */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var lastTrigger = null;
  var openDrawerEl = null;

  function setTriggersExpanded(id, value) {
    $$('[aria-controls="' + id + '"]').forEach(function (t) { t.setAttribute('aria-expanded', value ? 'true' : 'false'); });
  }

  function openDrawer(drawer, trigger) {
    if (!drawer) return;
    if (openDrawerEl && openDrawerEl !== drawer) closeDrawer(openDrawerEl, false);
    lastTrigger = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTriggersExpanded(drawer.id, true);
    openDrawerEl = drawer;
    var panel = $('.drawer__panel', drawer);
    setTimeout(function () {
      var first = $(FOCUSABLE, panel);
      (first || panel).focus();
    }, 60);
  }

  function closeDrawer(drawer, restoreFocus) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    setTriggersExpanded(drawer.id, false);
    openDrawerEl = null;
    if (restoreFocus !== false && lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer(document.getElementById(openBtn.getAttribute('data-drawer-open')), openBtn);
      return;
    }
    var cartBtn = e.target.closest('[data-cart-drawer-open]');
    if (cartBtn && $('[data-cart-drawer]')) {
      e.preventDefault();
      openDrawer($('[data-cart-drawer]'), cartBtn);
      return;
    }
    var closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) {
      e.preventDefault();
      closeDrawer(closeBtn.closest('[data-drawer]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!openDrawerEl) return;
    if (e.key === 'Escape') { closeDrawer(openDrawerEl); return; }
    if (e.key !== 'Tab') return;
    var items = $$(FOCUSABLE, $('.drawer__panel', openDrawerEl)).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ------------------------------------------------------------------
     Search panel
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-search-toggle]');
    if (!toggle) return;
    var panel = document.getElementById('SearchPanel');
    if (!panel) return;
    e.preventDefault();
    var willOpen = panel.hidden;
    panel.hidden = !willOpen;
    toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (willOpen) { var input = $('input[type="search"]', panel); if (input) input.focus(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var panel = document.getElementById('SearchPanel');
    if (panel && !panel.hidden) {
      panel.hidden = true;
      var toggle = $('[data-search-toggle]');
      if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
    }
  });

  /* ------------------------------------------------------------------
     Quantity steppers
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-quantity-minus]');
    var plus = e.target.closest('[data-quantity-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('[data-quantity]');
    var input = $('input', wrap);
    var min = parseInt(input.min || '0', 10);
    var value = parseInt(input.value || '0', 10) || 0;
    value = plus ? value + 1 : Math.max(min, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------
     Cart: section rendering
     ------------------------------------------------------------------ */
  function cartPageSectionId() {
    var page = $('[data-cart-page]');
    if (!page) return null;
    var wrap = page.closest('.shopify-section');
    return wrap ? wrap.id.replace('shopify-section-', '') : null;
  }

  function sectionsToRender() {
    var list = ['cart-drawer', 'cart-icon-bubble'];
    var pageId = cartPageSectionId();
    if (pageId) list.push(pageId);
    return list;
  }

  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function renderSections(sections) {
    if (!sections) return;
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var src = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (bubble && src) bubble.innerHTML = src.innerHTML;
    }
    if (sections['cart-drawer']) {
      var inner = document.getElementById('CartDrawerInner');
      var newInner = parse(sections['cart-drawer']).getElementById('CartDrawerInner');
      if (inner && newInner) inner.innerHTML = newInner.innerHTML;
    }
    var pageId = cartPageSectionId();
    if (pageId && sections[pageId]) {
      var current = document.getElementById('shopify-section-' + pageId);
      var fresh = parse(sections[pageId]).getElementById('shopify-section-' + pageId);
      if (current && fresh) current.innerHTML = fresh.innerHTML;
    }
  }

  function setLoading(on) {
    $$('[data-cart-form]').forEach(function (f) { f.classList.toggle('is-loading', on); });
  }

  function changeLine(line, quantity, focusLine) {
    setLoading(true);
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: sectionsToRender(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || strings.cartError);
        renderSections(res.data.sections);
        announce(strings.cartUpdated || '');
        if (focusLine) {
          var el = $('[data-cart-drawer].is-open [data-line="' + focusLine + '"] input') || $('[data-cart-page] [data-line="' + focusLine + '"] input');
          if (el) el.focus();
        }
      })
      .catch(function (err) {
        $$('[data-cart-errors]').forEach(function (el) { el.textContent = err.message || strings.cartError; });
      })
      .finally(function () { setLoading(false); });
  }

  var lineTimers = {};
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-quantity]');
    if (!input) return;
    var line = parseInt(input.getAttribute('data-line'), 10);
    clearTimeout(lineTimers[line]);
    lineTimers[line] = setTimeout(function () {
      var qty = Math.max(0, parseInt(input.value || '0', 10) || 0);
      changeLine(line, qty, qty > 0 ? line : null);
    }, 350);
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-line-remove]');
    if (!remove) return;
    e.preventDefault();
    changeLine(parseInt(remove.getAttribute('data-line-remove'), 10), 0);
  });

  // Keep the cart drawer and the cart page from submitting the form on Enter.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-form]');
    if (form && !(e.submitter && e.submitter.name === 'checkout')) e.preventDefault();
  });

  // Cart note (cart page)
  var noteTimer;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }, 500);
  });

  /* ------------------------------------------------------------------
     Add to cart
     ------------------------------------------------------------------ */
  var useDrawer = !!$('[data-cart-drawer]') && !!$('[data-cart-drawer-open]');

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || form.closest('[data-cart-form]')) return;
    if (!useDrawer) return; // cart type "page": let the native form submit to /cart/add
    e.preventDefault();

    var buttons = $$('button[name="add"]', form).concat($$('button[form="' + form.id + '"]'));
    var errorEl = $('[data-form-error]', form);
    if (errorEl) errorEl.textContent = '';
    buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });

    var body = new FormData(form);
    body.append('sections', sectionsToRender().join(','));
    body.append('sections_url', window.location.pathname);

    fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || strings.cartError);
        renderSections(res.data.sections);
        openDrawer($('[data-cart-drawer]'), e.submitter || buttons[0]);
      })
      .catch(function (err) {
        if (errorEl) errorEl.textContent = err.message || strings.cartError;
        else announce(err.message || strings.cartError);
      })
      .finally(function () {
        buttons.forEach(function (b) {
          b.removeAttribute('aria-busy');
          b.disabled = b.hasAttribute('data-sold-out-state');
        });
      });
  });

  /* ------------------------------------------------------------------
     Product page: variants, gallery, zoom, sticky bar
     ------------------------------------------------------------------ */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section.parentNode);
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    var form = $('[data-product-form]', section);
    var select = $('[data-variant-select]', section);
    var stickyBtn = $('[data-sticky-add]');
    var stickyPrice = $('[data-sticky-price]');

    function setAvailability(variant) {
      var addBtn = $('[data-add-button]', section);
      var label = $('[data-add-label]', section);
      var avail = $('[data-availability]', section);
      var text = !variant ? strings.unavailable : (variant.available ? strings.addToCart : strings.soldOut);
      [addBtn, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !variant || !variant.available;
        if (b.disabled) b.setAttribute('data-sold-out-state', ''); else b.removeAttribute('data-sold-out-state');
      });
      if (label) label.textContent = text;
      if (stickyBtn) stickyBtn.textContent = text;
      if (avail) {
        avail.textContent = variant && variant.available ? strings.inStock : (variant ? strings.soldOut : strings.unavailable);
        avail.classList.toggle('availability--out', !(variant && variant.available));
      }
    }

    if (select && form) {
      select.addEventListener('change', function () {
        var id = parseInt(select.value, 10);
        var variant = data.variants.filter(function (v) { return v.id === id; })[0];
        $('[data-variant-id]', form).value = id;
        if (variant) {
          var priceEl = $('[data-product-price] .price__regular', section);
          if (priceEl) priceEl.textContent = variant.price;
          if (stickyPrice) stickyPrice.textContent = variant.price;
          if (variant.media_id) goToMedia(variant.media_id);
        }
        setAvailability(variant);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url.toString());
      });
    }

    // Gallery
    var gallery = $('[data-gallery]', section);
    var viewport = gallery && $('[data-gallery-viewport]', gallery);
    var thumbs = gallery ? $$('[data-gallery-thumb]', gallery) : [];
    var counter = gallery && $('[data-gallery-current]', gallery);
    var slides = viewport ? $$('.gallery__slide', viewport) : [];

    function setActive(index) {
      thumbs.forEach(function (t, i) { if (i === index) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      if (counter) counter.textContent = index + 1;
    }
    function goTo(index) {
      if (!slides[index]) return;
      viewport.scrollTo({ left: slides[index].offsetLeft - viewport.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      setActive(index);
    }
    function goToMedia(mediaId) {
      slides.forEach(function (s, i) { if (String(s.getAttribute('data-media-id')) === String(mediaId)) goTo(i); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-gallery-thumb'), 10)); }); });
    if (viewport && slides.length > 1) {
      var scrollTimer;
      viewport.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          setActive(Math.round(viewport.scrollLeft / viewport.clientWidth));
        }, 80);
      }, { passive: true });
      viewport.addEventListener('keydown', function (e) {
        var current = Math.round(viewport.scrollLeft / viewport.clientWidth);
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(slides.length - 1, current + 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, current - 1)); }
      });
    }

    // Zoom dialog
    var dialog = $('[data-zoom-dialog]');
    if (dialog && typeof dialog.showModal === 'function') {
      var zoomImg = $('[data-zoom-image]', dialog);
      var zoomTrigger = null;
      $$('[data-zoom]', section).forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          zoomTrigger = link;
          zoomImg.src = link.getAttribute('data-zoom');
          zoomImg.alt = link.getAttribute('data-zoom-alt') || '';
          dialog.showModal();
          $('[data-zoom-close]', dialog).focus();
        });
      });
      $('[data-zoom-close]', dialog).addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog || e.target.classList.contains('zoom-dialog__inner')) dialog.close(); });
      dialog.addEventListener('close', function () { if (zoomTrigger) zoomTrigger.focus(); });
    }

    // Sticky add to cart (mobile only via CSS)
    var sticky = $('[data-sticky-atc]');
    var mainBtn = $('[data-add-button]', section);
    if (sticky && mainBtn) {
      document.body.classList.add('has-sticky-atc');
      var update = function () {
        // Visible only once the main button has scrolled above the viewport.
        var show = mainBtn.getBoundingClientRect().bottom < 0;
        if (show === sticky.classList.contains('is-visible')) return;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    }
  }

  /* ------------------------------------------------------------------
     Product recommendations
     ------------------------------------------------------------------ */
  function initRecommendations() {
    $$('[data-recommendations-url]').forEach(function (el) {
      fetch(el.getAttribute('data-recommendations-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = parse(html).querySelector('section');
          if (fresh && fresh.innerHTML.trim().length && !fresh.hasAttribute('hidden')) {
            el.innerHTML = fresh.innerHTML;
            el.hidden = false;
          }
        })
        .catch(function () {});
    });
  }

  /* ------------------------------------------------------------------
     Collection sort
     ------------------------------------------------------------------ */
  // Before/after comparison
  document.addEventListener('input', function (e) {
    var range = e.target.closest('[data-compare-range]');
    if (range) range.closest('[data-compare]').style.setProperty('--position', range.value + '%');
  });

  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-sort-select]');
    if (sort) sort.form.submit();
  });

  /* ------------------------------------------------------------------
     Reveal on scroll
     ------------------------------------------------------------------ */
  /* ------------------------------------------------------------------
     Premium motion: split headline, parallax, smart header, story, hotspots
     ------------------------------------------------------------------ */
  var motionOn = !reduceMotion && document.documentElement.classList.contains('animations');

  function splitLines(el) {
    if (el.classList.contains('is-split')) return;
    var text = el.textContent.trim().replace(/\s+/g, ' ');
    var words = text.split(' ');
    el.textContent = '';
    var spans = words.map(function (w, i) {
      var s = document.createElement('span');
      s.textContent = w + (i < words.length - 1 ? ' ' : '');
      s.style.display = 'inline';
      el.appendChild(s);
      return s;
    });
    var lines = [];
    var lastTop = null;
    spans.forEach(function (s) {
      var top = s.offsetTop;
      if (lastTop === null || Math.abs(top - lastTop) > 4) { lines.push([]); lastTop = top; }
      lines[lines.length - 1].push(s.textContent);
    });
    el.setAttribute('aria-label', text);
    el.textContent = '';
    lines.forEach(function (line, i) {
      var outer = document.createElement('span');
      outer.className = 'split-line';
      outer.setAttribute('aria-hidden', 'true');
      var inner = document.createElement('span');
      inner.style.setProperty('--line', i);
      inner.textContent = line.join('').trim() + (i < lines.length - 1 ? ' ' : '');
      outer.appendChild(inner);
      el.appendChild(outer);
    });
    el.classList.add('is-split');
  }

  function initSplit() {
    // The line-by-line headline animation only runs on desktop; elsewhere keep the heading as plain text.
    if (!motionOn || !window.matchMedia('(min-width: 990px)').matches) { $$('[data-split-lines]').forEach(function (el) { el.classList.add('is-split'); }); return; }
    $$('[data-split-lines]').forEach(splitLines);
  }

  function initParallax() {
    if (!motionOn || !window.matchMedia('(min-width: 990px)').matches) return;
    var items = $$('[data-parallax]');
    if (!items.length) return;
    var update = function () {
      var y = window.scrollY;
      if (y > window.innerHeight * 1.2) return;
      items.forEach(function (el) {
        el.style.translate = '0 ' + (y * parseFloat(el.getAttribute('data-parallax'))).toFixed(1) + 'px';
      });
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initHeader() {
    var inner = $('[data-header]');
    if (!inner) return;
    // Use the Shopify section wrapper: it is the element that sticks to the top.
    var header = inner.closest('.shopify-section') || inner;
    var setHeaderHeight = function () {
      document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    };
    setHeaderHeight();
    if ('ResizeObserver' in window) new ResizeObserver(setHeaderHeight).observe(header);
    else window.addEventListener('resize', setHeaderHeight, { passive: true });
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 10);
      var openPanel = document.getElementById('SearchPanel');
      var busy = openDrawerEl || (openPanel && !openPanel.hidden) || header.contains(document.activeElement);
      if (y > lastY + 6 && y > 240 && !busy) header.classList.add('is-hidden');
      else if (y < lastY - 6 || y <= 240) header.classList.remove('is-hidden');
      document.documentElement.classList.toggle('header-hidden', header.classList.contains('is-hidden'));
      lastY = y;
    }, { passive: true });
    header.addEventListener('focusin', function () {
      header.classList.remove('is-hidden');
      document.documentElement.classList.remove('header-hidden');
    });
  }

  function initStory() {
    $$('[data-story]').forEach(function (story) {
      var steps = $$('[data-story-step]', story);
      var images = $$('[data-story-image]', story);
      var counter = $('[data-story-current]', story);
      var current = -1;
      var update = function () {
        var mid = window.innerHeight * 0.5;
        var best = 0;
        var bestDist = Infinity;
        steps.forEach(function (s, i) {
          var r = s.getBoundingClientRect();
          var d = Math.abs(r.top + r.height / 2 - mid);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        if (best === current) return;
        current = best;
        steps.forEach(function (s, i) { s.classList.toggle('is-active', i === best); });
        images.forEach(function (img, i) { img.classList.toggle('is-active', i === best); });
        if (counter) counter.textContent = best + 1;
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  document.addEventListener('click', function (e) {
    var spot = e.target.closest('[data-hotspot]');
    $$('[data-hotspot][aria-expanded="true"]').forEach(function (b) {
      if (b === spot) return;
      b.setAttribute('aria-expanded', 'false');
      var c = document.getElementById(b.getAttribute('aria-controls'));
      if (c) c.hidden = true;
    });
    if (!spot) return;
    var card = document.getElementById(spot.getAttribute('aria-controls'));
    var open = spot.getAttribute('aria-expanded') !== 'true';
    spot.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (card) card.hidden = !open;
  });

  /* ------------------------------------------------------------------
     Lifestyle gallery: lightbox + mobile carousel progress
     ------------------------------------------------------------------ */
  function initGalleries(root) {
    $$('[data-lightbox-gallery]', root).forEach(function (gallery) {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      var dialog = $('[data-lightbox]', gallery);
      var img = dialog && $('[data-lightbox-image]', dialog);
      var counter = dialog && $('[data-lightbox-current]', dialog);
      var triggers = $$('[data-lightbox-open]', gallery);
      var index = 0;
      var opener = null;

      function show(i) {
        if (!triggers.length) return;
        index = (i + triggers.length) % triggers.length;
        var t = triggers[index];
        var src = t.getAttribute('data-src');
        if (img.getAttribute('src') !== src) {
          img.classList.add('is-loading');
          img.onload = function () { img.classList.remove('is-loading'); };
          img.src = src;
        }
        img.alt = t.getAttribute('data-alt') || '';
        if (counter) counter.textContent = index + 1;
        // Preload neighbours so arrows feel instant.
        [index + 1, index - 1].forEach(function (n) {
          var nt = triggers[(n + triggers.length) % triggers.length];
          if (nt) { var pre = new Image(); pre.src = nt.getAttribute('data-src'); }
        });
      }

      if (dialog && typeof dialog.showModal === 'function') {
        triggers.forEach(function (t, i) {
          t.addEventListener('click', function () { opener = t; show(i); dialog.showModal(); $('[data-lightbox-close]', dialog).focus(); });
        });
        $('[data-lightbox-close]', dialog).addEventListener('click', function () { dialog.close(); });
        $('[data-lightbox-prev]', dialog).addEventListener('click', function () { show(index - 1); });
        $('[data-lightbox-next]', dialog).addEventListener('click', function () { show(index + 1); });
        dialog.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') show(index - 1);
          if (e.key === 'ArrowRight') show(index + 1);
        });
        dialog.addEventListener('click', function (e) { if (e.target === dialog || e.target.classList.contains('lightbox__figure')) dialog.close(); });
        dialog.addEventListener('close', function () { if (opener) opener.focus(); });
        if (triggers.length < 2) $$('.lightbox__nav', dialog).forEach(function (b) { b.hidden = true; });
      }

      var track = $('[data-mosaic]', gallery);
      var bar = $('[data-mosaic-progress]', gallery);
      if (track && bar) {
        var update = function () {
          var max = track.scrollWidth - track.clientWidth;
          var visible = track.clientWidth / track.scrollWidth;
          var pct = max > 0 ? visible + (1 - visible) * (track.scrollLeft / max) : 1;
          bar.style.setProperty('--progress', (pct * 100).toFixed(1) + '%');
        };
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        update();
      }
    });
  }

  /* ------------------------------------------------------------------
     Hair quiz
     ------------------------------------------------------------------ */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (key === 'amount_with_comma_separator') return parts[0] + ',' + parts[1];
      return withCommas;
    });
  }

  function addItemsToCart(items, trigger) {
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionsToRender(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || strings.cartError);
        renderSections(res.data.sections);
        if (useDrawer) openDrawer($('[data-cart-drawer]'), trigger);
        else window.location.href = routes.cart_url;
      });
  }

  function initQuiz(root) {
    $$('[data-quiz]', root).forEach(function (quiz) {
      if (quiz.dataset.ready) return;
      quiz.dataset.ready = 'true';
      var data = JSON.parse($('[data-quiz-data]', quiz).textContent);
      var S = data.strings;
      // Translations arrive HTML-escaped (e.g. "&amp;"); decode them once for plain-text use.
      var decoder = document.createElement('textarea');
      Object.keys(S).forEach(function (k) { if (k.indexOf('upsell') !== 0) { decoder.innerHTML = S[k]; S[k] = decoder.value; } });
      var form = $('[data-quiz-form]', quiz);
      var steps = $$('[data-quiz-q]', quiz);
      var bar = $('[data-quiz-bar]', quiz);
      var count = $('[data-quiz-count]', quiz);
      var back = $('[data-quiz-back]', quiz);
      var loading = $('[data-quiz-loading]', quiz);
      var result = $('[data-quiz-result]', quiz);
      var current = 0;
      var answers = {};
      var recommended = [];

      function showStep(i) {
        current = i;
        steps.forEach(function (s, n) { s.hidden = n !== i; s.classList.toggle('is-active', n === i); });
        bar.style.width = ((i + 1) / steps.length * 100) + '%';
        count.textContent = S.step.replace('{{ current }}', i + 1).replace('{{ total }}', steps.length);
        back.hidden = i === 0;
        var legend = $('legend', steps[i]);
        if (legend) { legend.setAttribute('tabindex', '-1'); legend.focus({ preventScroll: true }); }
      }

      function recommend() {
        var a = answers;
        var list = [];
        function add(role, reason, freq) {
          var p = data.products[role];
          if (!p || list.some(function (x) { return x.role === role; })) return;
          list.push({ role: role, product: p, reason: reason, freq: freq });
        }
        add('shampoo', a.scalp === 'dry' ? S.reason_shampoo_dry : S.reason_shampoo, S.every_wash);
        add('conditioner', a.concern === 'flat' ? S.reason_conditioner_flat : S.reason_conditioner, S.every_wash);
        if (a.concern === 'dry_ends' || a.treated === 'yes') add('mask', S.reason_mask, S.weekly);
        if (a.concern === 'frizz') add('leave_in', S.reason_leave_in, S.as_needed);
        if (a.concern === 'frizz' || a.concern === 'dry_ends') add('oil', a.scalp === 'oily' ? S.reason_oil_oily : S.reason_oil, S.as_needed);
        var order = ['shampoo', 'conditioner', 'mask', 'leave_in', 'oil'];
        list.sort(function (x, y) { return order.indexOf(x.role) - order.indexOf(y.role); });
        return list;
      }

      function renderResult() {
        recommended = recommend();
        var title = { frizz: S.title_frizz, dry_ends: S.title_dry_ends, flat: S.title_flat }[answers.concern] || '';
        $('[data-quiz-result-title]', quiz).textContent = title;
        var ul = $('[data-quiz-products]', quiz);
        ul.innerHTML = '';
        var total = 0;
        recommended.forEach(function (item) {
          var p = item.product;
          if (p.available) total += p.price;
          var li = document.createElement('li');
          li.className = 'quiz__product';
          li.innerHTML =
            '<a class="quiz__product-media media media--contain" href="' + p.url + '" tabindex="-1" aria-hidden="true">' +
              (p.image ? '<img src="' + p.image + '" alt="" width="120" height="120" loading="lazy">' : '') + '</a>' +
            '<div><span class="pill pill--small"></span><a class="quiz__product-title" href="' + p.url + '"></a>' +
            '<p class="quiz__product-reason"></p></div>' +
            '<span class="quiz__product-price"></span>';
          $('.pill', li).textContent = item.freq;
          $('.quiz__product-title', li).textContent = p.title;
          $('.quiz__product-reason', li).textContent = item.reason;
          $('.quiz__product-price', li).textContent = p.available ? formatMoney(p.price, data.money_format) : S.unavailable;
          ul.appendChild(li);
        });
        $('[data-quiz-total]', quiz).textContent = formatMoney(total, data.money_format);

        // Upsell the complete set with honest maths (sum of all five vs. set price).
        var upsell = $('[data-quiz-upsell]', quiz);
        var b = data.bundle;
        var allFive = ['shampoo', 'conditioner', 'mask', 'leave_in', 'oil'].map(function (r) { return data.products[r]; });
        if (b && b.available && recommended.length >= 3 && allFive.every(Boolean)) {
          var separately = allFive.reduce(function (s, p) { return s + p.price; }, 0);
          var saving = separately - b.price;
          if (saving > 0) {
            upsell.innerHTML = '<p></p><button type="button" class="button button--secondary button--full" data-quiz-bundle></button>';
            $('p', upsell).innerHTML = (recommended.length === allFive.length ? S.upsell_all : S.upsell)
              .replace('{{ price }}', formatMoney(b.price, data.money_format))
              .replace('{{ saving }}', formatMoney(saving, data.money_format));
            $('[data-quiz-bundle]', upsell).textContent = S.upsell_button;
            upsell.hidden = false;
          } else { upsell.hidden = true; }
        } else { upsell.hidden = true; }
      }

      form.addEventListener('change', function (e) {
        if (e.target.type !== 'radio') return;
        answers[e.target.name] = e.target.value;
        if (current < steps.length - 1) {
          setTimeout(function () { showStep(current + 1); }, reduceMotion ? 0 : 220);
          return;
        }
        form.hidden = true;
        count.hidden = true;
        loading.hidden = false;
        setTimeout(function () {
          renderResult();
          loading.hidden = true;
          result.hidden = false;
          result.focus({ preventScroll: true });
          bar.style.width = '100%';
        }, reduceMotion ? 300 : 1600);
      });

      back.addEventListener('click', function () { if (current > 0) showStep(current - 1); });

      $('[data-quiz-restart]', quiz).addEventListener('click', function () {
        answers = {};
        form.reset();
        form.hidden = false;
        count.hidden = false;
        result.hidden = true;
        showStep(0);
      });

      var addBtn = $('[data-quiz-add]', quiz);
      var err = $('[data-quiz-error]', quiz);
      function busy(btn, on) { btn.disabled = on; if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy'); }

      addBtn.addEventListener('click', function () {
        var items = recommended.filter(function (x) { return x.product.available; }).map(function (x) { return { id: x.product.variant_id, quantity: 1 }; });
        if (!items.length) return;
        err.textContent = '';
        busy(addBtn, true);
        addItemsToCart(items, addBtn).catch(function (e) { err.textContent = e.message; }).finally(function () { busy(addBtn, false); });
      });

      quiz.addEventListener('click', function (e) {
        var bb = e.target.closest('[data-quiz-bundle]');
        if (!bb || !data.bundle) return;
        err.textContent = '';
        busy(bb, true);
        addItemsToCart([{ id: data.bundle.variant_id, quantity: 1 }], bb).catch(function (er) { err.textContent = er.message; }).finally(function () { busy(bb, false); });
      });

      showStep(0);
      // showStep focuses the first legend; undo that on page load.
      if (document.activeElement && quiz.contains(document.activeElement)) document.activeElement.blur();
    });

    // Floating launcher: hide while the quiz itself is on screen.
    // Floating launcher: hidden while the hero (which has its own quiz button) or the quiz itself is on screen.
    var launcher = $('[data-quiz-launcher]');
    var watched = [$('[data-quiz]'), $('[data-hero]')].filter(Boolean);
    if (launcher && watched.length && 'IntersectionObserver' in window) {
      var visible = new Set();
      launcher.classList.add('is-hidden');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
        launcher.classList.toggle('is-hidden', visible.size > 0);
      }, { threshold: 0.05 });
      watched.forEach(function (el) { io.observe(el); });
    }
  }

  /* ------------------------------------------------------------------
     Carousels (arrows + progress)
     ------------------------------------------------------------------ */
  function initCarousels(root) {
    $$('[data-carousel]', root).forEach(function (c) {
      if (c.dataset.ready) return;
      c.dataset.ready = 'true';
      var track = $('[data-carousel-track]', c);
      var prev = $('[data-carousel-prev]', c);
      var next = $('[data-carousel-next]', c);
      var bar = $('[data-carousel-progress]', c);
      if (!track) return;
      var step = function () {
        var item = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      };
      var update = function () {
        var max = track.scrollWidth - track.clientWidth;
        var visible = track.clientWidth / track.scrollWidth;
        if (bar) bar.style.setProperty('--progress', ((visible + (1 - visible) * (max > 0 ? track.scrollLeft / max : 1)) * 100).toFixed(1) + '%');
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
        var nav = c.querySelector('.carousel-nav');
        if (nav) nav.hidden = max <= 2;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  function initReveal() {
    var items = $$('.reveal, .reveal-mask');
    if (reduceMotion || !('IntersectionObserver' in window) || !document.documentElement.classList.contains('animations')) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  // Split the headline once web fonts are ready so line breaks are measured correctly.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(initSplit);
  else initSplit();

  document.addEventListener('DOMContentLoaded', function () {
    $$('[data-product-section]').forEach(initProduct);
    initRecommendations();
    initReveal();
    initParallax();
    initHeader();
    initStory();
    initGalleries(document);
    initQuiz(document);
    initCarousels(document);
  });

  // Theme editor: re-run when sections are re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-section]', e.target).forEach(initProduct);
    $$('[data-split-lines]', e.target).forEach(function (el) { el.classList.add('is-split'); });
    initGalleries(e.target);
    initQuiz(e.target);
    initCarousels(e.target);
    initStory();
    $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-visible'); });
  });
})();
